export const createImage = (className, src = ``, title = ``) => {
  const img = document.createElement(`img`);
  img.className = className;
  img.src = src;
  img.alt = title;

  return img;
};
